import React from 'react';

import {
  
 SportingCP,
 Benfica,
 Porto,
 Boavista,
 Belenenses,

} from "../clubs";

const PrimeiraLiga = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Primeira Liga.</h1>
      <SportingCP />
      <Benfica />
      <Porto />
      <Boavista /> 
      <Belenenses />
    </div>
  )
}

export default PrimeiraLiga